"use client";

import { useEffect, useState, useRef } from "react";
import { FaArrowUp } from "react-icons/fa";

export default function ScrollToTop() {
    const [isVisible, setIsVisible] = useState(false);
    const footerRef = useRef<HTMLElement | null>(null);

    useEffect(() => {
        const observer = new IntersectionObserver(
            ([entry]) => {
                setIsVisible(entry.isIntersecting);
            },
            {
                root: null,
                threshold: 0.1
            }
        );

        footerRef.current = document.querySelector("footer");
        if (footerRef.current) {
            observer.observe(footerRef.current);
        }

        return () => {
            if (footerRef.current) {
                observer.unobserve(footerRef.current);
            }
        };
    }, []);

    const scrollToTop = () => {
        window.scrollTo({ top: 0, behavior: "smooth" });
    };

    return isVisible ? (
        <button
            onClick={scrollToTop}
            aria-label="Voltar ao topo"
            className="fixed bottom-8 left-4 z-10 p-2 rounded-lg border-1 bg-black text-white shadow-lg hover:bg-gray-100 transition-all block md:hidden"
        >
            <FaArrowUp size={20} />
        </button>
    ) : null;
}
